import { PropertyDetailsContainer } from 'components/modules/Properties/Details/Profile';

export const PropertyDetails = () => <PropertyDetailsContainer />;
